import { render, staticRenderFns } from "./ApplicantDashboard.vue?vue&type=template&id=006cc89a&scoped=true"
import script from "./ApplicantDashboard.vue?vue&type=script&lang=js"
export * from "./ApplicantDashboard.vue?vue&type=script&lang=js"
import style0 from "./ApplicantDashboard.vue?vue&type=style&index=0&id=006cc89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006cc89a",
  null
  
)

export default component.exports